// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-green[data-v-4514b620] {\n  color: green;\n}\n.text-orange[data-v-4514b620] {\n  color: orange;\n}\n.text-white[data-v-4514b620] {\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
